export default "/images/84b730ef3db0e27f6042d0ce5f612af9.avif";